angular.module('cfn').directive('cfnInputEnum', [
  '$rootScope',
  '$log',
  function($rootScope, $log) {
    return {
      restrict: 'E',
      scope: {
        model: '=',
        class: '@',
        readonly: '=',
        disabled: '=',
        required: '@?',
        enumName: '@',
        optional: '@',
        options: '=?',
        change: '&'
      },
      replace: true,
      template:
        '<select ng-model="model" title="{{$rootScope.enums[enumName][model]}}" ng-options="opt as $rootScope.enums[enumName][opt]?($rootScope.enums[enumName][opt]+\' \'):\'\' for opt in realOptions" class="{{class}}" ng-readonly="readonly" ng-disabled="(disabled || readonly)" ng-required="{{required}}"></select>',
      link: function(scope, element, attrs) {
        scope.$rootScope = $rootScope;

        scope.onChange = function() {
          if (scope.change) scope.change();
        };
        function updateOptions(value) {
          if (attrs.options == 'item.unit_options') {
            console.debug('options change', value, scope.options);
          }
          if (
            !value ||
            value === '' ||
            scope.options === undefined ||
            scope.options === null
          ) {
            if (!$rootScope.enums[scope.enumName]) {
              console.error('enum not found ' + scope.enumName);
            } else scope.realOptions = $rootScope.enums[scope.enumName].options;
          } else {
            scope.realOptions = scope.options;
          }
          if (scope.optional) {
            var opt = [undefined];
            if (scope.realOptions)
              $.each(scope.realOptions, function(k, v) {
                opt.push(v);
              });
            scope.realOptions = opt;
          }
        }

        // call change event
        $(element).change(function() {
          // callafter is used because we need to ensure that the model has been set before
          ang.callAfter(function() {
            if (scope.change) scope.change();
          }, scope);
        });

        scope.$watch('options', updateOptions);
        if (scope.enumName) {
          scope.$on(scope.enumName, function() {
            scope.model = undefined;
            updateOptions();
          });
        }
        scope.getOpt = function(opt) {
          if (opt === '') return '';
          return $rootScope.enums[scope.enumName][opt];
        };
      }
    };
  }
]);

angular.module('cfn').directive('cfnPopoverButton', [
  '$rootScope',
  '$log',
  function($rootScope, $log) {
    return {
      restrict: 'E',
      scope: {
        result: '&',
        class: '@',
        readonly: '=',
        popupData: '=',
        titletext: '@',
        url: '@',
        required: '@',
        param: '=param',
        serviceParam: '@',
        pathExt: '@',
        placement: '@'
      },
      transclude: true,
      replace: true,
      template:
        '<span class="popover-btn">' +
        '<button type="button" popover-append-to-body="true" ' +
        'popover-result="onResult" ' +
        'popover-animation="true" ' +
        'popover-titletext="{{ titletext }}" ' +
        'popover-placement="{{placement}}" ' +
        'data365-popover="{{url}}" ' +
        'class="btn popover-btn {{class}}" ' +
        'ng-transclude="">' +
        '</button>' +
        '</span>',
      link: function(scope, element, attrs) {
        scope.$rootScope = $rootScope;
        scope.onResult = function(ob) {
          ob.forEach(function(element) {
            scope.result()(element);
          });
        };

        attrs.$observe('placement', function(val) {
          scope.placement = angular.isDefined(val) ? val : 'bottom';
        });

        scope.getParam = function() {
          return scope.param;
        };
      }
    };
  }
]);
